// Shared Sky Theme System
// Used by both the Landing Page and the Dashboard so the visual experience
// (8K UFO backdrop, accent color, glow) stays cohesive across the whole app.

// PUBLIC THEMES - Available to all users (random selection)
export const publicThemes = {
  crystal: {
    name: "Crystal Clear",
    nameTranslations: {
      en: "Crystal Clear", es: "Cristal Claro", fr: "Cristal Clair", de: "Kristallklar",
      zh: "水晶透明", ja: "クリスタルクリア", pt: "Cristal Claro", ar: "كريستال صافي",
      ru: "Кристально Чистый", ko: "크리스탈 클리어"
    },
    image: "https://static.prod-images.emergentagent.com/jobs/3a9a6ba0-202e-4c8f-8ae0-b0ecce5f76d9/images/666192851a44bf15c91ae035bb01a02589f04647803940daaebf38089fc4305a.png",
    overlay: "rgba(0,0,0,0.1)",
    blur: "blur(0px)",
    accent: "#00ff88",
    glow: "rgba(0,255,136,0.5)",
    gradient: "radial-gradient(ellipse at center, rgba(0,10,20,0.3) 0%, rgba(0,5,10,0.7) 70%)"
  },
  frosted: {
    name: "Frosted Glass",
    nameTranslations: {
      en: "Frosted Glass", es: "Vidrio Esmerilado", fr: "Verre Givré", de: "Milchglas",
      zh: "磨砂玻璃", ja: "フロストガラス", pt: "Vidro Fosco", ar: "زجاج مصنفر",
      ru: "Матовое Стекло", ko: "프로스티드 글라스"
    },
    image: "https://static.prod-images.emergentagent.com/jobs/3a9a6ba0-202e-4c8f-8ae0-b0ecce5f76d9/images/e06038760ec1316478ad2e95869e083ea6cf2f525da083a20d69b3ec35eb4eef.png",
    overlay: "rgba(0,20,30,0.15)",
    blur: "blur(4px)",
    accent: "#00ffcc",
    glow: "rgba(0,255,204,0.3)",
    gradient: "radial-gradient(ellipse at center, rgba(0,40,50,0.4) 0%, rgba(0,10,15,0.7) 70%)"
  },
  holographic: {
    name: "Holographic",
    nameTranslations: {
      en: "Holographic", es: "Holográfico", fr: "Holographique", de: "Holografisch",
      zh: "全息", ja: "ホログラフィック", pt: "Holográfico", ar: "هولوغرافي",
      ru: "Голографический", ko: "홀로그래픽"
    },
    image: "https://static.prod-images.emergentagent.com/jobs/3a9a6ba0-202e-4c8f-8ae0-b0ecce5f76d9/images/653c5841a6aaf0a36c55a0bc51a1bb25dc1f086597c58557a31c5b175336ea18.png",
    overlay: "rgba(10,0,20,0.1)",
    blur: "blur(0px)",
    accent: "#ff66ff",
    glow: "rgba(255,102,255,0.3)",
    gradient: "radial-gradient(ellipse at center, rgba(30,10,40,0.35) 0%, rgba(10,5,15,0.7) 70%)"
  }
};

// OWNER-ONLY THEMES - Creepy/Scary themes only for owner/premium mode
export const ownerThemes = {
  abduction: {
    name: "Abduction",
    nameTranslations: {
      en: "Abduction", es: "Abducción", fr: "Enlèvement", de: "Entführung",
      zh: "绑架", ja: "アブダクション", pt: "Abdução", ar: "اختطاف",
      ru: "Похищение", ko: "납치"
    },
    image: "https://static.prod-images.emergentagent.com/jobs/3a9a6ba0-202e-4c8f-8ae0-b0ecce5f76d9/images/00c9833b5af475885fe3668af48ebcb9a25a3e8a88dc9a115445d23b4e308b2d.png",
    overlay: "rgba(0,0,0,0.05)",
    blur: "blur(0px)",
    accent: "#ff3333",
    glow: "rgba(255,50,50,0.4)",
    gradient: "radial-gradient(ellipse at center, rgba(30,5,5,0.3) 0%, rgba(10,0,0,0.7) 70%)"
  },
  invasion: {
    name: "Invasion",
    nameTranslations: {
      en: "Invasion", es: "Invasión", fr: "Invasion", de: "Invasion",
      zh: "入侵", ja: "侵略", pt: "Invasão", ar: "غزو",
      ru: "Вторжение", ko: "침공"
    },
    image: "https://static.prod-images.emergentagent.com/jobs/3a9a6ba0-202e-4c8f-8ae0-b0ecce5f76d9/images/bb0125e644ef9e99dc4a75da0d07e5107e036579dc7e236d3e3ec49c36792fb0.png",
    overlay: "rgba(0,0,0,0.05)",
    blur: "blur(0px)",
    accent: "#66ff66",
    glow: "rgba(100,255,100,0.4)",
    gradient: "radial-gradient(ellipse at center, rgba(10,15,10,0.3) 0%, rgba(5,10,5,0.7) 70%)"
  },
  encounter: {
    name: "Close Encounter",
    nameTranslations: {
      en: "Close Encounter", es: "Encuentro Cercano", fr: "Rencontre Rapprochée", de: "Nahbegegnung",
      zh: "近距离接触", ja: "接近遭遇", pt: "Encontro Imediato", ar: "لقاء قريب",
      ru: "Близкий Контакт", ko: "근접 조우"
    },
    image: "https://static.prod-images.emergentagent.com/jobs/3a9a6ba0-202e-4c8f-8ae0-b0ecce5f76d9/images/9dad50aa52c20ff404abed9b0b92298359f51e5be8186d74bc073d458bd85056.png",
    overlay: "rgba(0,0,0,0.1)",
    blur: "blur(0px)",
    accent: "#aaaaaa",
    glow: "rgba(180,180,180,0.3)",
    gradient: "radial-gradient(ellipse at center, rgba(20,20,20,0.35) 0%, rgba(5,5,5,0.75) 70%)"
  },
  monolith: {
    name: "Monolith",
    nameTranslations: {
      en: "Monolith", es: "Monolito", fr: "Monolithe", de: "Monolith",
      zh: "巨石", ja: "モノリス", pt: "Monólito", ar: "متراصة",
      ru: "Монолит", ko: "모노리스"
    },
    image: "https://static.prod-images.emergentagent.com/jobs/3a9a6ba0-202e-4c8f-8ae0-b0ecce5f76d9/images/623f944e65dde545c1fa45d7e146cdcd773ecc2021aa50506d4066d8a5b11912.png",
    overlay: "rgba(0,0,0,0.05)",
    blur: "blur(0px)",
    accent: "#cc66ff",
    glow: "rgba(200,100,255,0.4)",
    gradient: "radial-gradient(ellipse at center, rgba(20,10,30,0.3) 0%, rgba(10,5,15,0.7) 70%)"
  },
  apocalypse: {
    name: "Apocalypse",
    nameTranslations: {
      en: "Apocalypse", es: "Apocalipsis", fr: "Apocalypse", de: "Apokalypse",
      zh: "末日", ja: "黙示録", pt: "Apocalipse", ar: "نهاية العالم",
      ru: "Апокалипсис", ko: "종말"
    },
    image: "https://static.prod-images.emergentagent.com/jobs/3a9a6ba0-202e-4c8f-8ae0-b0ecce5f76d9/images/e22fe5b9eca3cee50a9f3aef79e8031e3c794bec98cfd9a4ad1f9332f07b6f61.png",
    overlay: "rgba(0,0,0,0.05)",
    blur: "blur(0px)",
    accent: "#ff6600",
    glow: "rgba(255,100,0,0.5)",
    gradient: "radial-gradient(ellipse at center, rgba(25,10,0,0.3) 0%, rgba(15,5,0,0.7) 70%)"
  }
};

// Combined themes for premium/owner mode
export const getAllThemes = () => ({ ...publicThemes, ...ownerThemes });

// Theme keys for random selection
export const allThemeKeys = [...Object.keys(publicThemes), ...Object.keys(ownerThemes)];
export const publicThemeKeys = Object.keys(publicThemes);

export const ACTIVE_SKY_THEME_KEY = 'skybot_active_sky_theme';

// Resolve a theme object from a key, falling back to a public default
export const resolveSkyTheme = (key) => getAllThemes()[key] || publicThemes.crystal;
